<!-- Container for the sidebar navigation list component -->
<sb-nav-list
  [navLinks]="navLinks"
  [minNav]="minNav()"
  [activeProgress]="activeProgress()"
  (mainItemClick)="onMainItemClick($event)"
  (chevronClick)="onChevronClick($event)"
  (subItemClick)="onSubItemClick($event)">
</sb-nav-list>
